/* Menu burger PLEIN ÉCRAN « façon Loban » (sous 1150 px) — docs/superpowers/specs/2026-10-03-moola-facon-loban.md, § 4.3.
   S'appuie sur window.MoolaTiroir (moola-tiroir-base.js) : dialogue modal, focus piégé, Échap et croix, verrou du
   défilement sur <html> et <body>, bandeaux cookies masqués, focus rendu au burger à la fermeture.
   Ce script ajoute :
   - la conversion du burger (lien vers /collections sans JavaScript) en bouton d'ouverture ;
   - les sous-menus en panneaux glissants : le niveau 1 part à gauche pendant que le niveau 2 arrive de la droite
     (300 ms), bouton retour en tête, focus posé sur ce bouton puis rendu à l'entrée parente au retour ;
   - la remise au niveau 1 à chaque réouverture ;
   - la fermeture si la fenêtre passe à 1150 px ou plus (la barre complète de l'en-tête prend le relais). */
(function () {
  var menu = document.querySelector('[data-moola-menu]');
  var burger = document.querySelector('[data-moola-burger]');
  if (!menu || !burger || !window.MoolaTiroir) { return; }
  var DUREE = 420;   // dévoilement de 400 ms (clip-path) : `hidden` n'est reposé qu'après l'animation de fermeture
  var racine = menu.querySelector('[data-niveau="1"]');
  var actif = null, parent = null;

  // Le menu vit directement sous <body> : aucun ancêtre transformé (l'en-tête glisse par transform) ne peut le rogner.
  if (menu.parentElement !== document.body) { document.body.appendChild(menu); }

  burger.setAttribute('role', 'button');
  burger.setAttribute('aria-controls', menu.id);
  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-haspopup', 'dialog');

  function inerte(el, oui) { if ('inert' in el) { el.inert = oui; } else if (oui) { el.setAttribute('inert', ''); } else { el.removeAttribute('inert'); } }
  function haut(niveau) { var d = niveau.querySelector('.moola-menu__defile'); if (d) { d.scrollTop = 0; } }

  // Retour immédiat au niveau 1, sans animation (à chaque ouverture).
  function niveau1() {
    menu.classList.add('sans-transition');
    if (actif) { actif.classList.remove('est-actif'); inerte(actif, true); }
    if (parent) { parent.setAttribute('aria-expanded', 'false'); }
    actif = null; parent = null;
    menu.classList.remove('a-sous');
    inerte(racine, false); haut(racine);
    void menu.offsetWidth;
    menu.classList.remove('sans-transition');
  }

  function ouvrirSous(bouton) {
    var panneau = document.getElementById(bouton.getAttribute('aria-controls'));
    if (!panneau) { return; }
    parent = bouton; actif = panneau;
    haut(panneau);
    inerte(panneau, false);
    panneau.classList.add('est-actif');
    menu.classList.add('a-sous');
    bouton.setAttribute('aria-expanded', 'true');
    inerte(racine, true);
    var retour = panneau.querySelector('[data-moola-retour]');
    if (retour) { retour.focus({ preventScroll: true }); }
  }

  function revenir() {
    if (!actif) { return; }
    var p = actif, b = parent;
    inerte(racine, false);
    menu.classList.remove('a-sous');
    p.classList.remove('est-actif');
    inerte(p, true);
    if (b) { b.setAttribute('aria-expanded', 'false'); b.focus({ preventScroll: true }); }
    actif = null; parent = null;
  }

  burger.addEventListener('click', function (e) {
    e.preventDefault();
    niveau1();
    window.MoolaTiroir.ouvrir(menu, { declencheur: burger, duree: DUREE });
  });
  burger.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); burger.click(); } });

  menu.addEventListener('click', function (e) {
    var b = e.target.closest('[data-moola-sous]');
    if (b && menu.contains(b)) { ouvrirSous(b); return; }
    if (e.target.closest('[data-moola-retour]')) { revenir(); }
  });

  var large = window.matchMedia('(min-width: 1150px)');
  var bascule = function () { if (large.matches && window.MoolaTiroir.ouvert(menu)) { window.MoolaTiroir.fermer(menu, true); } };
  if (large.addEventListener) { large.addEventListener('change', bascule); } else if (large.addListener) { large.addListener(bascule); }
})();
